/**
 * Klab MMP Report API
 *
 * Contact: jesuspalominomartinez1234@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppTopItemWithPercentage { 
    processName: string;
    totalSeconds: number;
    classification?: AppTopItemWithPercentage.ClassificationEnum;
}
export namespace AppTopItemWithPercentage {
    export const ClassificationEnum = {
        Productive: 'PRODUCTIVE',
        Unproductive: 'UNPRODUCTIVE',
        Neutral: 'NEUTRAL'
    } as const;
    export type ClassificationEnum = typeof ClassificationEnum[keyof typeof ClassificationEnum];
}


